import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { X } from 'lucide-react';
import { BUILD_TIME, VERSION } from '../../version';
import './WebsiteVersionDialog.css';

export default function WebsiteVersionDialog({ onClose, outdated = false, english = false }) {
  const builtAt = BUILD_TIME && Number.isFinite(Date.parse(BUILD_TIME))
    ? new Intl.DateTimeFormat('zh-CN', {
      timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
    }).format(new Date(BUILD_TIME)) : '—';
  return (
    <Dialog open onClose={onClose} className="website-version">
      <DialogBackdrop className="website-version__backdrop" />
      <div className="website-version__position">
        <DialogPanel className="website-version__panel">
          <header className="website-version__header">
            <DialogTitle>{english ? 'Website version' : '网站版本'}</DialogTitle>
            <button type="button" className="website-version__dismiss" onClick={onClose} aria-label={english ? 'Close dialog' : '关闭弹窗'}>
              <X size={18} aria-hidden="true" />
            </button>
          </header>
          <div className="website-version__body">
            <dl>
              <div><dt>{english ? 'Version' : '当前版本'}</dt><dd>{VERSION}</dd></div>
              <div><dt>{english ? 'Built at' : '构建时间'}</dt><dd><time dateTime={BUILD_TIME || undefined}>{builtAt}</time><span className="website-version__timezone">{english ? '(Beijing time)' : '（北京时间）'}</span></dd></div>
            </dl>
            <p className={`website-version__status${outdated ? ' is-outdated' : ''}`} role={outdated ? 'alert' : 'status'}>
              {outdated
                ? (english ? 'The latest version could not be loaded. Please refresh the page later.' : '暂未载入最新版本，请稍后刷新页面。')
                : (english ? 'Automatically updated to the latest version.' : '已自动更新至最新版本。')}
            </p>
          </div>
          <footer className="website-version__footer">
            <button type="button" data-autofocus onClick={onClose}>{english ? 'Close' : '关闭'}</button>
          </footer>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
